<template>
  <div class="verify-idcard">
    <h3 class="name">身份证人像面照片</h3>
    <van-uploader :after-read="afterRead1">
      <div class="upload-box flex flex-column align-items-center justify-content-center" slot="default" >
        <img src="@/assets/imgs/loan/apply/icon_id_card_verify.png" class="icon_pic" v-if="!positiveImg">
        <div class="flex align-items-center" v-if="!positiveImg">
          <!-- <img src="@/assets/imgs/icon/camera.png" alt="" class="icon"> -->
          <p>点击拍照/上传身份证人像面</p>
        </div>
        <img :src="positiveImg" alt="" class="id-card" v-else>
      </div>
    </van-uploader>
    <h3 class="name">身份证国徽面照片</h3>
    <van-uploader :after-read="afterRead2">
      <div class="upload-box flex flex-column align-items-center justify-content-center" slot="default">
        <img src="@/assets/imgs/loan/apply/icon_id_card_verify.png" class="icon_pic" v-if="!reserveSideImg">
        <div class="flex align-items-center" v-if="!reserveSideImg">
          <!-- <img src="@/assets/imgs/icon/camera.png" alt="" class="icon"> -->
          <p>点击拍照/上传身份证国徽面</p>
        </div>
        <img :src="reserveSideImg" alt="" class="id-card" v-else>
      </div>
    </van-uploader>
    <div class="tips">
      <p>仅用于全国公民身份查询中心核实身份</p>
      <p>拍摄时请确保身份证边框完整、字迹清晰、亮度均衡</p>
    </div>
    <div class="btn-wrap flex justify-content-center">
      <input type="button" value="下一步" class="lg-btn lg-btn-new" @click="nextStep">
    </div>
    <van-popup v-model="showResult" class="my-dialog">
      <img src="@/assets/imgs/other/group.png" alt="">
      <h3 class="title margin-b10">身份有误将影响授信结果，请确认</h3>
      <div><p>姓名：{{OCRData.name}}</p><p>身份证号：{{OCRData.idcard}}</p><p>出生日期：{{OCRData.birth}}</p><p>手机号：{{phone}}</p></div>
      <input type="button" value="重新扫描" class="hollow-btn" @click="reScan">
      <input type="button" value="确认无误" class="mid-btn" @click="confirm">
    </van-popup>
  </div>
</template>

<script>
  import {Uploader} from 'vant';
  import {
	identifyIDCard,
	identifyTrue,
	reqUpload,
	UpdateRegisterInfo,
	reqSystemInfo,
	reqCheckRegister,
	reqMobileCheck,
	repeatCheck
  } from '@/api';
  import {mapState} from 'vuex';
  import Exif from 'exif-js';
  import sensors from 'sa-sdk-javascript'

  export default {
    components: {
      [Uploader.name]: Uploader,
    },
    data() {
      return {
        positiveImg: '',
        reserveSideImg: '',
        sign: '', // 身份证OCR识别签名
        idCardInfo: {}, //身份证正面识别信息
        reserveSideInfo: {}, //身份证反面识别信息
        idCardBefore: '', // 身份证正面照
        idCardBack: '', // 身份证背面照
        enterTime: 0,
        ocrNode: '',
        showResult: false,
      }
    },
    computed: {
      ...mapState(['appId', 'signTicket', 'version', 'freeLoanData', 'userInfo', 'OCRData']),
      phone() {
        let phone
        if (this.freeLoanData.phoneNo) {
          phone = this.freeLoanData.phoneNo
        } else {
          phone = localStorage.phone
        }
        return phone
      },
    },
    created() {
      this.$dialog.alert({
        title: "提示",
        message: "拍摄时请把手机横放，镜头与身份证边框对齐，请勿竖着手机拍摄！",
        showCancelButton: true
      });
      let path = localStorage.getItem('verifyPath');
      if(path === '/verified-result2') {
        this.ocrNode = '实名认证';
      }else if(path === '/free-loan/bankcard-bind') {
        this.ocrNode = '申请流程';
      }
    },
    methods: {
      afterRead1(file) {
        this.getIDCardInfo(0, file)
      },

      afterRead2(file) {
        this.getIDCardInfo(1, file)
      },

      async getIDCardInfo(cardType, file) {
        //大于500K就压缩图片
        console.log("---原图片size:"+file.file.size)
        if (file.file.size > 512000) {
          let canvas = document.createElement('canvas')//创建Canvas对象(画布)
          let context = canvas.getContext('2d')
          let img = new Image()
          img.src = file.content//指定图片的DataURL(图片的base64编码数据)
          // 监听浏览器加载图片完成，然后进行进行绘制
          img.onload = () => {
            //获取图片角度
            let Orientation = '';
            Exif.getData(img, function () {
              Exif.getAllTags(this)
              Orientation = Exif.getTag(this, 'Orientation')
            });
            // console.log("---图片Orientation:"+Orientation)
            // this.$dialog.alert({
            //   title: "提示",
            //   message: "图片Orientation:"+Orientation,
            //   showCancelButton: true
            // });
            //设置压缩
            console.log("---原图Width:"+img.width+",原图Height:"+img.height);
            let comWidth = 1200;//设置固定宽度
            let comHeight = Math.ceil(img.height/img.width * comWidth);//按照固定宽度比例压缩
            console.log("---缩放后height:"+comHeight);
            canvas.width = comWidth
            canvas.height = comHeight
            //根据拍照角度旋转（目前测试都是6）
            if (Orientation !== '' && Orientation !== 1) {
              switch (Orientation) {
                case 6://顺时针90°
                  this.rotateImg(img, 'right', canvas, comWidth, comHeight)
                  break;
                case 8://逆时针90°
                  this.rotateImg(img, 'left', canvas, comWidth, comHeight)
                  break;
                case 3://180°
                  this.rotateImg(img, 'right2', canvas, comWidth, comHeight)
                  break;
                default:
                  context.drawImage(img, 0, 0, comWidth, comHeight)
                  break;
              }
            } else {
              context.drawImage(img, 0, 0, comWidth, comHeight)
            }
            file.content = canvas.toDataURL(file.file.type, 0.9) //默认压缩质量
            //转换base64成file类型
            let arr = file.content.split(',')
            let mime = arr[0].match(/:(.*?);/)[1]
            let bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n)
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            file.file = new Blob([u8arr], { type: 'image/jpeg' })
            console.log("---压缩后size:"+file.file.size)//压缩后大概220K
            if (parseInt(cardType) === 0) {
              this.positiveImg = file.content;
            } else {
              this.reserveSideImg = file.content;
            }
            this.uploadAction(cardType, file);
          }
        } else {
          this.uploadAction(cardType, file);
        }
      },

      rotateImg(img, direction, canvas, width, height) {
        var min_step = 0;
        var max_step = 3;
        if (img == null) {
          return;
        }
        var step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == 'right') {
          step++;
          step > max_step && (step = min_step);
        } else if (direction == 'right2') {
          step = 2;
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        var degree = step * 90 * Math.PI / 180;
        var ctx = canvas.getContext('2d');
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height, width, height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height, width, height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0, width, height);
            break;
        }
      },

      //实际的上传操作，身份证人像面0，国徽面1
      uploadAction(cardType, file) {
        this.enterTime = new Date().getTime() / 1000;
        let imgStr = file.content.split(',')[1].toString();
        let mthis = this;
        //识别图片后上传
        identifyIDCard({
          cardType,
          idcardStr: imgStr
        }).then(res => {
          console.log("---identifyIDCard_res:"+ JSON.stringify(res));
          let result = JSON.parse(res);
          console.log("---identifyIDCard_result_code:"+ result.code);
          console.log("---identifyIDCard_result_info:"+ JSON.stringify(result.info));
          if (result.info) {//有值说明当前是商汤的API
            if (result.code !== 1000) {//失败
              sensors.track('OCRrecognition', {
                product_name: sessionStorage.getItem('tempProductName'),
                photo_type: parseInt(cardType) === 0 ? '身份证正面' : '身份证反面',
                ocr_node: this.ocrNode,
                is_success: false,
                fail_reason: result.message
              });
              this.$toast(result.message)
              return
            }
          } else {
            //否则是腾讯的API
            if (result.code !== '0') {//失败
              sensors.track('OCRrecognition', {
                product_name: sessionStorage.getItem('tempProductName'),
                photo_type: parseInt(cardType) === 0 ? '身份证正面' : '身份证反面',
                ocr_node: this.ocrNode,
                is_success: false,
                fail_reason: result.msg
              });
              this.$toast(result.msg)
              return
            }
          }
          //识别成功
          sensors.track('OCRrecognition', {
            product_name: sessionStorage.getItem('tempProductName'),
            photo_type: parseInt(cardType) === 0 ? '身份证正面' : '身份证反面',
            ocr_node: this.ocrNode,
            is_success: true,
          });
          if (parseInt(cardType) === 0) {
            // 人像面信息
            if (Object.keys(this.userInfo.idNo).length === 0 || this.userInfo.idNo === result.result.idcard) {
              this.positiveImg = file.content
              reqUpload({fileType: file.file.type.split('/')[1], binaryCode: file.content}).then(res => {
                this.idCardBefore = res.attachURL
              })
              if (result.info) {
                //商谈的数据转成腾讯数据格式
                let monthStr = (result.info.month.length === 1) ? "0" + result.info.month : result.info.month;
                let dayStr = (result.info.day.length === 1) ? "0" + result.info.day : result.info.day;
                mthis.idCardInfo = {
                  name: result.info.name,
                  sex: result.info.gender,
                  nation: result.info.nation,
                  birth: result.info.year + monthStr + dayStr,
                  address: result.info.address,
                  idcard: result.info.number,
                };
              } else {
                this.idCardInfo = result.result;
              }
            } else {
              sensors.track('OCRrecognition_result', {
                product_name: sessionStorage.getItem('tempProductName'),
                consume_time: new Date().getTime() / 1000 - mthis.enterTime,
                ocr_node: mthis.ocrNode,
                is_success: false,
                fail_reason: '身份证信息与注册信息不一致'
              });
              this.$dialog.alert({
                title: "提示",
                message: "抱歉！您扫描的身份证信息与注册信息不一致，请重新扫描或洽询客服专线！",
                showCancelButton: true
              });
              this.positiveImg = '';
            }
          } else {
            // 国徽面信息
            let expData;
            if (result.info) {//有值说明当前是商汤的API
              expData = result.info.timelimit.split('-')[1];
            } else {//否则是腾讯的API
              expData = result.result.validDate.split('-')[1];
            }
            let curDate = mthis.getCurDate();
            console.log("---expData:"+expData+",curData:"+curDate);
            console.log("---差值："+(expData-curDate));
            if ((expData - curDate) > 0) {
              this.reserveSideImg = file.content
              reqUpload({fileType: file.file.type.split('/')[1], binaryCode: file.content}).then(res => {
                this.idCardBack = res.attachURL
              })
              if (result.info) {//有值说明当前是商汤的API
                mthis.reserveSideInfo = {
                  authority: result.info.authority,
                  validDate: result.info.timelimit,
                };
              } else {
                this.reserveSideInfo = result.result
              }
            } else {
              sensors.track('OCRrecognition_result', {
                product_name: sessionStorage.getItem('tempProductName'),
                consume_time: new Date().getTime() / 1000 - mthis.enterTime,
                ocr_node: mthis.ocrNode,
                is_success: false,
                fail_reason: '身份证已过期'
              });
              this.$dialog.alert({
                title: "提示",
                message: "抱歉！您扫描的身份证已过期！",
                showCancelButton: true
              });
              this.reserveSideImg = '';
            }
          }
        }).catch(err => {
          this.$dialog.alert({
            title: "提示",
            message: '抱歉，发生未知错误！',
            showCancelButton: true
          });
          if (parseInt(cardType) === 0) {
            this.positiveImg = '';
          } else {
            this.reserveSideImg = '';
          };
          sensors.track('OCRrecognition', {
            product_name: sessionStorage.getItem('tempProductName'),
            photo_type: parseInt(cardType) === 0 ? '身份证正面' : '身份证反面',
            ocr_node: this.ocrNode,
            is_success: false,
            fail_reason: '接口异常错误'
          });
        })
      },

      nextStep() {
        let mthis = this;
        let path = localStorage.getItem('verifyPath')
        let {idCardInfo, reserveSideInfo } = this;

        if(!idCardInfo.idcard) {
          this.$toast('请上传身份证正面照')
          return;
        }
        if(!reserveSideInfo.validDate) {
          this.$toast('请上传身份证反面照')
          return;
        }
        // 将识别出来的身份证信息存到vuex
        this.$store.commit('setOCRData', {...idCardInfo, ...reserveSideInfo})

        let birthday = this.filterDate(idCardInfo.birth)
        let attach = [
          {
            type: '03',
            URL: this.idCardBefore
          },
          {
            type: '70',
            URL: this.idCardBack
          }
        ]
        // let prodCode = path === '/free-loan/bankcard-bind' ? 'PD0003' : ''
        let params = {
          idNo: idCardInfo.idcard,
          name: idCardInfo.name,
          sex: idCardInfo.sex == '男' ? '1' : '2',
          nationality: idCardInfo.nation,
          birthday: birthday,
          address: idCardInfo.address,
          currentAddress: this.userInfo.address,
          issuingAgency: reserveSideInfo.authority,
          idStartDate: this.filterDate(reserveSideInfo.validDate.split('-')[0]),
          expirationDate: this.filterDate(reserveSideInfo.validDate.split('-')[1]),
          prodCode: this.freeLoanData.productCode,
          attach: attach
        }
        this.freeLoanData.birthday = birthday
        this.freeLoanData.sex = idCardInfo.sex == '男' ? '1' : '2'
        localStorage.setItem("idCardAddress", idCardInfo.address);
        identifyTrue(params).then(res => {
          // if(res && (parseInt(res.similarity) < 90)) {
          //   this.$toast('人脸相似度对比得分低于90')
          // }
          sensors.track('OCRrecognition_result', {
            product_name: sessionStorage.getItem('tempProductName'),
            consume_time: new Date().getTime() / 1000 - mthis.enterTime,
            ocr_node: mthis.ocrNode,
            is_success: true,
          });
          if(path === '/free-loan/bankcard-bind') {
            this.showResult = true;
            // this.$router.push('/verified-result')
          }else if(path === '/verified-result2') {
            this.freeLoanData.name = idCardInfo.name //姓名
            this.freeLoanData.idNo = idCardInfo.idcard //身份证号
            this.showResult = true;
            // this.$router.push('/verified-result')
            // this.$router.push('/verified-step2')
          }
        }).catch(err => {
          this.$dialog.alert({
            title: "提示",
            message: err.data.resMessage,
            showCancelButton: true
          });
          sensors.track('OCRrecognition_result', {
            product_name: sessionStorage.getItem('tempProductName'),
            consume_time: new Date().getTime() / 1000 - mthis.enterTime,
            ocr_node: mthis.ocrNode,
            is_success: true,
            fail_reason: err.data.resMessage
          });
        })
      },

      filterDate(date) {
        return date.slice(0,4) + '-' + date.slice(4,6) + '-' + date.slice(6,8)
      },

      //yyyyMMdd格式
      getCurDate() {
        const date = new Date();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "" + month + "" + strDate;
      },

      reScan() {
        this.showResult = false;
      },
      confirm() {
        this.checkAndUpdate();
      },

      checkAndUpdate() {
        // reqSystemInfo({
        //   queryType: 1,
        //   phoneNo: this.userInfo.phoneNo
        // }).then(res => {
        // })
          this.doRealUpdate();
      },

      doRealUpdate() {
        let { OCRData, userInfo, freeLoanData } = this;
        if (userInfo.idNo) {
          freeLoanData.effectDay = OCRData.validDate.split('-')[1] //身份证有效日期
          freeLoanData.name = userInfo.name //姓名
          freeLoanData.idNo = OCRData.idcard //身份证号
          this.$store.dispatch('updateUserInfo').then(res => {
			let params2 = {
			  prodCode: freeLoanData.productCode,
			  mobile: freeLoanData.phoneNo,
			  idNo: OCRData.idcard,
			  checkBlack: 'false',
			  contactCount: '20',
			}
			//重复性校验
			repeatCheck(params2).then(res => {
			  this.$router.push('/signProtol')
			}).catch(err => {
			  this.$dialog.alert({
				title: "提示",
				message: "该产品暂时无法申请，您可下载APP选择其他产品",
				cancelButtonText: '下载APP',
				showCancelButton: true
			  }).then(function () {
			  }).catch(function () {
				let baseUrl = process.env.VUE_APP_URL.split("JmxApi")[0];
				window.location.href = baseUrl + 'Qrcode/#/downloadJmx';
			  });
			})
          })
        } else {
          // 检测判断身份证和手机号码有无异常情况，如在途案件、已绑定其它账号、还有未处理业务等
          reqCheckRegister({ idNo: OCRData.idcard, phoneNo: userInfo.phoneNo }).then(res => {
            //手机号验真
            reqMobileCheck({idNo: OCRData.idcard, phoneNo: userInfo.phoneNo, name: OCRData.name}).then(res => {
            //更新注册信息
              UpdateRegisterInfo({ idNo: OCRData.idcard, phoneNo: userInfo.phoneNo, name: OCRData.name, updateType: 1, expIDDate: OCRData.validDate.split('-')[1] }).then(res => {
                freeLoanData.effectDay = OCRData.validDate.split('-')[1] //身份证有效日期
                freeLoanData.name = OCRData.name //姓名
                freeLoanData.idNo = OCRData.idcard //身份证号
                this.$store.dispatch('updateUserInfo').then(res => {
				  let params2 = {
					prodCode: freeLoanData.productCode,
					mobile: freeLoanData.phoneNo,
					idNo: OCRData.idcard,
					checkBlack: 'false',
					contactCount: '20',
				  }
				  //重复性校验
				  repeatCheck(params2).then(res => {
					this.$router.push('/signProtol')
				  }).catch(err => {
					this.$dialog.alert({
					  title: "提示",
					  message: "该产品暂时无法申请，您可下载APP选择其他产品",
					  cancelButtonText: '下载APP',
					  showCancelButton: true
					}).then(function () {
					}).catch(function () {
					  let baseUrl = process.env.VUE_APP_URL.split("JmxApi")[0];
					  window.location.href = baseUrl + 'Qrcode/#/downloadJmx';
					});
				  })
                })
              }).catch(err => {
                this.$dialog.alert({
                  title: "提示",
                  message: err.data.resMessage,
                  showCancelButton: true
                });
              });
            }).catch(err =>{
              this.$dialog.alert({
                title: "提示",
                message: err.data.resMessage,
                showCancelButton: true
              });
            });
          }).catch(err =>{
            this.$dialog.alert({
              title: "提示",
              message: err.data.resMessage,
              showCancelButton: true
            });
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .lg-btn-new {
    width: 100%;
    background: #D89A26;
    border-radius: 5px 5px 5px 5px;
  }

  .name {
    font-size: 17px;
    font-weight: bold;
    padding: 20px 0 17px;
  }
  .upload-box {
    width: 335px;
    height: 180px;
    background-color: white;
    border-radius: 10px;
    // background: url('../assets/imgs/other/idcard.png') no-repeat;
    background-size: 100%;
    border-radius:13px;
    position: relative;
    .icon_pic {
      width: 67px;
      height: 67px;
      margin-bottom: 12px;
    }
    .id-card {
      width: 100%;
      height: 100%;
    }
    .icon {
      width: 17px;
      margin-right: 10px;
    }
    .tip {
      padding-bottom: 20px;
    }
  }
  .tips {
    text-align: center;
    line-height: 20px;
    color: #C7C7C7;
    font-size: 10px;
    padding: 20px 0 35px;
    margin-top: 92px;
  }
  .btn-wrap {
    padding-bottom: 33px;
  }


  .my-dialog {
    width: 331px;
    min-height: 345px;
    box-sizing: border-box;
    background: rgba(255,255,255,1);
    border-radius: 15px;
    padding: 20px 15px;
    text-align: center;
    .title {
      font-size: 17px;
    }
    .hollow-btn {
      margin-top: 20px;
      width: 125px;
      margin-right: 20px;
    }
    img {
      width: 130px;
      margin: 10px 0 20px;
    }
  }
</style>